<template>
  <div>
    <div class="">
      <div class="mb-6 mx-auto max-w-screen-xl px-4 sm:px-6">
        <div class="text-center">
          <h2
            class="text-4xl font-bebas tracking-wide leading-10 font-extrabold text-darkpurple mt-4"
          >
            Chat
          </h2>
        </div>
      </div>
      <topic-table></topic-table>
      <div>
        <div class=" mt-8 ">
          <if-can-take-part>
            <div
              class="max-w-screen-xl mx-auto text-center py-8 px-4 sm:px-6 lg:py-8 lg:px-8"
            >
              <div class="flex justify-center">
                <div class="inline-flex rounded-md shadow">
                  <button
                    @click="toggleModal"
                    class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-xl font-bebas tracking-wider
                   leading-6 font-medium rounded-md text-white bg-darkpurple hover:bg-peach
                  transition duration-150 ease-in-out"
                  >
                    Suggest a New Topic
                  </button>
                </div>
              </div>
            </div>
          </if-can-take-part>
        </div>
      </div>
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <new-topic-modal
          v-if="showNewTopicModal"
          v-on:topic-added="toggleModal"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import TopicTable from "./TopicTable";
import NewTopicModal from "./NewTopicModal";
import { mapGetters } from "vuex";
import IfCanTakePart from "./IfCanTakePart";
export default {
  name: "TopicView",
  components: { IfCanTakePart, NewTopicModal, TopicTable },
  data() {
    return {
      showNewTopicModal: false
    };
  },
  methods: {
    toggleModal() {
      this.showNewTopicModal = !this.showNewTopicModal;
    }
  },
  computed: {
    ...mapGetters(["loggedIn"])
  }
};
</script>

<style scoped></style>
